import itineraryImage from "./itinerary.png";
import "./styles.css";

export default function Itinerary() {
    return (
        <section className="itinerary-section">
            <h2 className="itinerary-title">ITINERARIO DE ACTIVIDADES</h2>
            <img
                src={itineraryImage}
                alt="Itinerario de actividades"
                className="itinerary-image"
            />
        </section>
    );
}
